export const OTP_LENGTH = 6;
// Must match the backend's OTP_EXPIRE_SECONDS (app/config.py / .env) — this only
// drives the countdown UI shown to the patient, the backend is the real source
// of truth for when a code actually expires.
export const OTP_VALIDITY_SECONDS = 300;
export const OTP_EXPIRY_WARNING_SECONDS = 15;
